import React from "react";
import Svg from "@/Components/Svg";
import classNames from "classnames";
import "@/Scss/Components/checkbox.scss";

export default function Checkbox(props) {
    const {
        name,
        value,
        onChange = () => {
        },
        label = '',
        textPosition = 'right',
        icon,
        checkedIcon,
        checked = false,
        disabled = false,
    } = props;

    const NotCheckedIcon = () => {
        if (icon) return icon;
        return <Svg id={`notChecked`} className={`svg__notChecked`} />
    };

    const CheckedIcon = () => {
        if (checkedIcon) return checkedIcon;
        return <Svg id={`checked`} className={`svg__checked`} />
    };

    const Icon = () => (checked ? <CheckedIcon /> : <NotCheckedIcon />);

    const checkboxContainer = classNames('checkboxContainer', props.className, {
        'right': textPosition === 'right',
        'left': textPosition === 'left',
        'disabled': disabled,
    });

    return (
        <label className={checkboxContainer}>
            <span className={`checkboxContainer__checkbox`}>
                <input name={name}
                       value={value}
                       type={`checkbox`}
                       checked={checked}
                       className={`checkboxInput`}
                       disabled={disabled}
                       onChange={(e) => onChange(e)}
                />
                <Icon />
            </span>
            {label !== '' && (
                <span className={`checkboxContainer__label`}>{label}</span>
            )}
        </label>
    );
}
